import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";

const lesson: Lesson = {
  id: "c4419348-2e49-4857-8c6b-4041140dce26",
  publicId: "27",
  name: "Application of simulation and auralization in research",
  difficulty: 1,
  contentTypes: { audio: false, interactive: false, video: true },
  body: [principle01, principle02, task01, task02],
};

export default lesson;
